// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    font-family: "Arial", sans-serif;
}
.ppad{
    padding-block: 60px;
}

.loginForm-body{
    margin: 0;
    padding: 0;
    font-family: 'Arial', sans-serif;
    background-color: #f0f0f0;
    color:#636363;
}
.signin-container{
    display: flex;
    flex-direction: column;
    place-content: center;
    background-color: #ffffff;
    color: #636363;
}

.loginForm-container {
    display: grid;
    place-items: center;
    min-height: 100dvh;
    height: auto;
    width: 100%;
}

.loginForm-logo-section{
    padding: 40px;
    text-align: left;
    border-radius: 7px;
    border: 1px solid #505050;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.loginForm-button-container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 20px;
}

.loginForm-description{
    margin-bottom: 30px;
    margin-top: 0;
}

.loginForm-header{
    background-image: radial-gradient(circle, #c09f53, #856a2b);
    color: #ffffff;
    display: grid;
    place-content: center;
    line-height: 1.4;
    grid-template-rows: 1fr;
    overflow: hidden;
}

.loginForm-header-content{
    margin: auto;
    width: 550px;
    padding-block: 40px;
}

.loginForm-header-content h1{
    font-size: 2em;
    font-weight: 600;
    margin: 0;
}

.loginForm-signup{
    padding: 10px 20px;
    background-color: #ffffff;
    color: #636363;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid #c09f53;
    border-radius: 30px;
    margin: 10px;
    text-decoration: none;
    font-size: 16px;
}

.loginForm-signup-2{
    text-decoration: none;
    color: #636363;
    margin-top: 20px;
    border-radius: 30px;
    padding: 10px 20px;
}

.loginForm-signup-2:hover, .loginForm-signup:hover{
    background-color: #c09f53;
    color: #ffffff;
    transition: all 0.3s ease;
    border: 1px solid #c09f53;
    cursor: pointer;
}

.loginForm-overlay {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    margin: auto;
    display: grid;
    place-content: center;
    background: rgba(0, 0, 0, .7);
}

.loginForm {
    width: 100%;
    height: 100%;
    margin: auto;
    background: radial-gradient(circle at top, rgba(188, 188, 188, .8) -10%, rgba(48, 48, 48, .6));
    padding: 80px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: rgb(234, 234, 234);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    grid-column: 2/3;
}

.loginForm-overlay .loginForm {
    width: 500px;
}

.loginForm label {
    text-align: left;
    display: block;
    padding: 5px 0px;
}

.loginForm-inputField {
    padding: 15px;
    border: none;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    margin: 2px 0px;
}

.loginForm-forget {
    padding: 15px;
    color: rgb(234, 234, 234);
    text-decoration: none;
    display: block;
    text-align: right;
}

.loginForm-logo {
    width: 400px;
}

.loginForm-logo.--hideMobile {
    display: none;
}

.intastellar-accounts-logo-container {
    margin-top: 90px;
    text-align: center;
}

.intastellar-accounts-logo{
    width: 110px;
}

.poweredBy {
    font-size: 12px;
    margin-bottom: 5px;
}

.loginForm-inputField.--btn {
    background-color: #c09f53;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    letter-spacing: 5px;
    text-transform: uppercase;
}

.loginForm-title {
    font-size: 1.70em;
    text-align: center;
}

.loginForm-service {
    margin: 0 0 10px;
}

.loginForm-inputField.--link {
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    text-align: center;
    display: block;
    margin: 10px 0px;
}

.graphic-container{
    height: 100%;
}

.main-content-section{
    padding: 50px;
    color: #636363;
}

.used_by {
    display: inline-block;
    width: 50%;
    height: 100px;
    object-fit: contain;
    object-position: center;
    margin-inline: 50px;
}

.feature-list{
    width: 1100px;
    margin-inline: auto;
}

.testimonials{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
}

.key-numbers-section{
    padding-block: 150px;
    background-color: #fff;
}

@media screen and (min-width: 375px) and (max-width: 900px) {
    .loginForm-container {
        grid-template-columns: 1fr;
    }

    .loginForm-logo-section{
        border: none;
    }

    .loginForm-logo {
        padding: 0;
        margin: 20px auto;
    }

    .loginForm-title{
        font-size: 1.1em;
        width: 100%;
        margin: 0 auto;
    }

        .loginForm-header{
        grid-template-columns: 1fr;
        }

    .loginForm-header-content{
        width: 100%;
        padding: 20px;
    }

    .loginForm {
        padding: 40px;
        background: radial-gradient(circle at top, rgba(188, 188, 188, .6) -10%, rgba(48, 48, 48, .4));
    }

    .loginForm-container {
        background-position: -250px;
        height: auto;
    }

    .signup {
        overflow: scroll;
    }

    .loginForm-header, .signin-container{
        height: auto !important;
    }

    .signin-container{
        padding: 60px;
    }

    .intastellar-accounts-logo-container{
        text-align: center;
    }

    .poweredBy{
        font-size: 12px;
        margin-bottom: 10px;
    }

    .intastellar-accounts-logo{
        margin-bottom: 70px;
    }

    .graphic-container{
        display: none;
    }

    .key-numbers-section{
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .used_by{
        width: 150px;
        margin: auto;
        display: flex;
    }
}

/* ——— Intastellar Consents login (Login.js only) ——— */
.int-login {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: #f7f4f0;
    color: #e8e8e8;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

/* ── Split layout ── */
.int-login__split {
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 100dvh;
}

.int-login__panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: clamp(32px, 5vw, 72px) clamp(24px, 4vw, 64px);
    box-sizing: border-box;
}

.int-login__panel--form {
    background: #f7f4f0;
}

.int-login__panel--features {
    position: relative;
    border-left: 1px solid rgba(255, 255, 255, 0.06);
    background:
        radial-gradient(ellipse 110% 60% at 60% 10%, rgba(192, 159, 83, 0.12), transparent 55%),
        linear-gradient(168deg, #141418 0%, #0c0c10 100%);
    overflow: hidden;
}

.int-login__panel--features::before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 80% 80% at 110% 110%, rgba(192, 159, 83, 0.07), transparent 60%);
    pointer-events: none;
}

/* ── Features inner content ── */
.int-login__features-inner {
    position: relative;
    width: 100%;
    max-width: 420px;
}

.int-login__features-brand {
    margin-bottom: 32px;
}

.int-login__features-logo {
    height: auto;
    max-width: min(100%, 230px);
    display: block;
    opacity: 0.88;
    filter: brightness(0) invert(1);
}

.int-login__features-headline {
    margin: 0 0 14px;
    font-size: clamp(1.5rem, 2.8vw, 2rem);
    font-weight: 700;
    line-height: 1.22;
    letter-spacing: -0.01em;
    color: #f4f0ea;
}

.int-login__features-lede {
    margin: 0 0 32px;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: #848a92;
}

.int-login__features-list {
    list-style: none;
    margin: 0 0 32px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.int-login__feature {
    display: flex;
    align-items: flex-start;
    gap: 14px;
}

.int-login__feature-icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9px;
    border: 1px solid rgba(192, 159, 83, 0.25);
    background: rgba(192, 159, 83, 0.09);
    color: #c0a053;
    margin-top: 1px;
}

.int-login__feature-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.int-login__feature-title {
    display: block;
    font-size: 0.9rem;
    font-weight: 600;
    color: #e8e4de;
}

.int-login__feature-desc {
    display: block;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: #6a7280;
}

/* ── Stats row ── */
.int-login__features-stats {
    display: flex;
    align-items: center;
    gap: 0;
    padding: 18px 20px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(0, 0, 0, 0.28);
}

.int-login__features-stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    text-align: center;
}

.int-login__features-stat-value {
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #c0a053;
}

.int-login__features-stat-label {
    font-size: 0.68rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.32);
}

.int-login__features-stat-divider {
    width: 1px;
    height: 28px;
    background: rgba(255, 255, 255, 0.07);
    flex-shrink: 0;
}

/* ── Light form panel overrides ── */
.int-login__panel--form .int-login__card {
    background: transparent;
    border: none;
    box-shadow: none;
    max-width: 360px;
}

.int-login__panel--form .int-login__card::before {
    display: none;
}

.int-login__panel--form .int-login__logo {
    filter: none;
    opacity: 1;
    max-width: min(100%, 300px);
}

.int-login__panel--form .int-login__headline {
    color: #1a1714;
    font-size: clamp(1.6rem, 3vw, 2rem);
    font-weight: 700;
    letter-spacing: -0.02em;
    text-align: left;
    margin-top: 36px;
}

.int-login__panel--form .int-login__lede {
    color: #7a7068;
    text-align: left;
    margin-bottom: 28px;
}

.int-login__panel--form .int-login__signin-btn {
    border-color: rgba(160, 128, 60, 0.5);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.18) 0%, rgba(160, 130, 60, 0.12) 100%);
    color: #3d2f0e;
    box-shadow: 0 2px 8px rgba(160, 128, 60, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.int-login__panel--form .int-login__signin-btn:hover:not(:disabled) {
    border-color: rgba(160, 128, 60, 0.7);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.26) 0%, rgba(160, 130, 60, 0.2) 100%);
    box-shadow: 0 4px 14px rgba(160, 128, 60, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.int-login__panel--form .int-login__signin-btn-inner-text {
    color: #3d2f0e;
}

.int-login__panel--form .int-login__signin-btn-inner-text-email {
    color: #7a6840;
}

.int-login__panel--form .int-login__signin-spinner {
    border-color: rgba(61, 47, 14, 0.2);
    border-top-color: #3d2f0e;
}

.int-login__panel--form .int-login__not-you {
    text-align: left;
}

.int-login__panel--form .int-login__not-you-link {
    color: #9a8a78;
}

.int-login__panel--form .int-login__not-you-link:hover {
    color: #a38540;
    border-bottom-color: rgba(163, 133, 64, 0.45);
}

.int-login__panel--form .int-login__divider {
    color: #9a8a78;
}

.int-login__panel--form .int-login__divider::before,
.int-login__panel--form .int-login__divider::after {
    background: rgba(0, 0, 0, 0.08);
}

.int-login__panel--form .int-login__new-here-title {
    color: #1a1714;
}

.int-login__panel--form .int-login__new-here-copy {
    color: #7a7068;
}

.int-login__panel--form .int-login__new-here-btn {
    border-color: rgba(160, 128, 60, 0.45);
    color: #3d2f0e;
}

.int-login__panel--form .int-login__new-here-btn:hover {
    border-color: rgba(160, 128, 60, 0.75);
    background: rgba(192, 159, 83, 0.1);
    color: #1a1714;
}

/* ── Responsive: collapse to single column on small screens ── */
@media (max-width: 860px) {
    .int-login__split {
        grid-template-columns: 1fr;
    }

    .int-login__panel--features {
        display: none;
    }

    .int-login__panel--form {
        min-height: 100dvh;
        padding: clamp(40px, 8vw, 80px) clamp(24px, 6vw, 48px);
    }

    .int-login__panel--form .int-login__card {
        max-width: 100%;
    }
}

.int-login__card {
    width: 100%;
    max-width: 440px;
    padding: clamp(28px, 4vw, 42px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: linear-gradient(
        168deg,
        rgba(54, 54, 58, 0.95) 0%,
        rgba(28, 28, 32, 0.98) 100%
    );
    box-shadow:
        0 28px 72px rgba(0, 0, 0, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    position: relative;
}

.int-login__card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 42%;
    max-width: 200px;
    height: 3px;
    border-radius: 0 0 8px 8px;
    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.9), transparent);
    pointer-events: none;
}

.int-login__brand {
    display: flex;
    justify-content: center;
    margin-bottom: 22px;
}

.int-login__logo {
    max-width: min(100%, 300px);
    height: auto;
    display: block;
}

/* First-visit clarity: product ↔ parent company (Login + Signup) */
.icc-product-parent-ribbon {
    margin: 0 0 20px;
    padding: 12px 14px;
    text-align: center;
    font-size: 0.8125rem;
    line-height: 1.45;
    color: #c4c4c4;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.35);
    background: linear-gradient(
        165deg,
        rgba(192, 159, 83, 0.12) 0%,
        rgba(0, 0, 0, 0.2) 100%
    );
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.icc-product-parent-ribbon__product {
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #f0e6d4;
}

.icc-product-parent-ribbon__sep {
    margin: 0 0.35em;
    color: rgba(192, 159, 83, 0.75);
    font-weight: 600;
}

.icc-product-parent-ribbon__rest {
    color: #a8a8a8;
}

.icc-product-parent-ribbon__link {
    color: #d4b87a;
    font-weight: 600;
    text-decoration: underline;
    text-decoration-color: rgba(192, 159, 83, 0.45);
    text-underline-offset: 2px;
}

.icc-product-parent-ribbon__link:hover {
    color: #e8d4a8;
    text-decoration-color: rgba(192, 159, 83, 0.85);
}

.loginForm-header-content .icc-product-parent-ribbon--signup {
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
}

.int-login__headline {
    margin: 0 0 12px;
    font-size: clamp(1.32rem, 3.6vw, 1.68rem);
    font-weight: 600;
    letter-spacing: 0.02em;
    text-align: center;
    line-height: 1.28;
    color: #f4f4f4;
}

.int-login__lede {
    margin: 0 0 18px;
    font-size: 0.9375rem;
    line-height: 1.55;
    text-align: center;
    color: #a3a3a3;
}

.int-login__trust {
    list-style: none;
    margin: 0 0 22px;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(0, 0, 0, 0.22);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.int-login__trust-item {
    position: relative;
    margin: 0;
    padding-left: 20px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #c6c6c6;
    line-height: 1.4;
    text-align: left;
}

.int-login__trust-item::before {
    content: "";
    position: absolute;
    left: 2px;
    top: 0.52em;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: linear-gradient(145deg, rgba(192, 159, 83, 0.95), rgba(192, 159, 83, 0.4));
    box-shadow: 0 0 10px rgba(192, 159, 83, 0.3);
}

.int-login__sso {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
}

/* Primary action — matches dashboard / settings gold CTA */
.int-login__signin-btn {
    width: 100%;
    margin: 0;
    padding: 14px 22px;
    border-radius: 12px;
    border: 1px solid rgba(192, 159, 83, 0.48);
    background: linear-gradient(
        180deg,
        rgba(192, 159, 83, 0.28) 0%,
        rgba(160, 130, 70, 0.2) 100%
    );
    display: flex;
    align-items: center;
    justify-content: center;
    color: #faf6ee;
    font-size: 0.9375rem;
    font-weight: 600;
    font-family: inherit;
    letter-spacing: 0.02em;
    line-height: 1.3;
    cursor: pointer;
    box-shadow:
        0 10px 28px rgba(0, 0, 0, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    transition:
        border-color 0.2s ease,
        background 0.2s ease,
        transform 0.15s ease,
        box-shadow 0.2s ease;
}

.int-login__signin-btn:hover:not(:disabled) {
    border-color: rgba(192, 159, 83, 0.72);
    background: linear-gradient(
        180deg,
        rgba(192, 159, 83, 0.38) 0%,
        rgba(160, 130, 70, 0.28) 100%
    );
    box-shadow:
        0 12px 32px rgba(0, 0, 0, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.int-login__signin-btn:active:not(:disabled) {
    transform: translateY(1px);
}

.int-login__signin-btn:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.75);
    outline-offset: 3px;
}

.int-login__signin-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
}

.int-login__signin-btn-inner {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.int-login__signin-btn-inner-image {
    width: 34px;
    height: 34px;
    border-radius: 50%;
}

.int-login__signin-btn-inner-text {
    font-size: 0.9375rem;
    font-weight: 600;
    color: #faf6ee;
}

.int-login__signin-spinner {
    width: 1.1em;
    height: 1.1em;
    border: 2px solid rgba(250, 246, 238, 0.25);
    border-top-color: #faf6ee;
    border-radius: 50%;
    animation: int-login-spin 0.65s linear infinite;
    flex-shrink: 0;
}

.int-login__signin-btn-inner-text-email {
    font-size: 0.8125rem;
    font-weight: 400;
    color: #c6c6c6;
    display: block;
}

@keyframes int-login-spin {
    to {
        transform: rotate(360deg);
    }
}

.int-login__not-you {
    margin: 14px 0 0;
    text-align: center;
}

.int-login__not-you-link {
    font-size: 0.8125rem;
    font-weight: 500;
    color: #8f9aad;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: color 0.2s ease, border-color 0.2s ease;
}

.int-login__not-you-link:hover {
    color: #c0a053;
    border-bottom-color: rgba(192, 159, 83, 0.45);
}

/* "New here?" — the login page is the de facto landing page for anyone
   arriving without an account, so this needs to be a real, discoverable
   section, not a buried link. Deliberately styled as a secondary/outline
   button (vs. the filled gold "Sign in" CTA) so returning users still land
   on Sign in first, but new visitors don't have to hunt for it. */
.int-login__divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 22px 0;
    color: #8f9aad;
    font-size: 0.6875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.int-login__divider::before,
.int-login__divider::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
}

.int-login__new-here-title {
    font-size: 1rem;
    font-weight: 700;
    color: #faf6ee;
    margin: 0 0 4px;
}

.int-login__new-here-copy {
    font-size: 0.8125rem;
    color: #9aa3b2;
    margin: 0 0 14px;
    line-height: 1.5;
}

.int-login__new-here-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px 22px;
    border-radius: 12px;
    border: 1px solid rgba(192, 159, 83, 0.4);
    background: transparent;
    color: #e7d9b8;
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-decoration: none;
    transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.int-login__new-here-btn:hover {
    border-color: rgba(192, 159, 83, 0.75);
    background: rgba(192, 159, 83, 0.08);
    color: #faf6ee;
}

/* SSO / identity trust (Login.js footer) */
.int-login__identity {
    margin-top: 26px;
    padding: 18px 16px 16px;
    border-radius: 12px;
    border: 1px solid rgba(192, 159, 83, 0.18);
    background: linear-gradient(
        165deg,
        rgba(192, 159, 83, 0.07) 0%,
        rgba(0, 0, 0, 0.28) 55%
    );
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.int-login__identity-strip {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-bottom: 16px;
}

.int-login__identity-icon {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: rgba(192, 159, 83, 0.1);
    border: 1px solid rgba(192, 159, 83, 0.22);
    color: #d4b76a;
}

.int-login__identity-svg {
    width: 26px;
    height: 26px;
    display: block;
}

.int-login__identity-copy {
    min-width: 0;
    flex: 1;
}

.int-login__identity-kicker {
    margin: 0 0 6px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #c0a053;
}

.int-login__identity-lede {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: #b0b0b0;
    text-align: left;
}

.int-login__identity-product {
    color: #e2e2e2;
    font-weight: 600;
}

.int-login__identity-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding-top: 14px;
    margin-top: 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    text-decoration: none;
    transition: opacity 0.2s ease;
}

.int-login__identity-brand:hover {
    opacity: 0.92;
}

.int-login__identity-brand:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.75);
    outline-offset: 4px;
    border-radius: 8px;
}

.int-login__identity-brand-label {
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #6a6a6a;
}

.int-login__identity-logo {
    height: auto;
    max-width: 128px;
    width: 100%;
    opacity: 0.95;
}

.int-login__identity-trustline {
    margin: 14px 0 0;
    padding-top: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 0.65rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    text-align: center;
    color: #5c6570;
    line-height: 1.45;
}

@media (max-width: 480px) {
    .int-login__card {
        padding: 24px 18px 28px;
        border-radius: 14px;
    }

    .int-login__lede {
        font-size: 0.875rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2DAA2D;IAC3D,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8FAA8F;IAC9F,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0CAA0C;IAC1C,kDAAkD;IAClD,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;;QAEI;QACA,0BAA0B;QAC1B;;IAEJ;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,8FAA8F;IAClG;;IAEA;QACI,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA,uDAAuD;AACvD;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,gGAAgG;AACpG;;AAEA,uBAAuB;AACvB;IACI,OAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;IACtD,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD;;yDAEqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oGAAoG;IACpG,oBAAoB;AACxB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,oCAAoC;IACpC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,+FAA+F;IAC/F,cAAc;IACd,sFAAsF;AAC1F;;AAEA;IACI,qCAAqC;IACrC,8FAA8F;IAC9F,sFAAsF;AAC1F;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,cAAc;AAClB;;AAEA,iEAAiE;AACjE;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,sDAAsD;IAC1D;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,2CAA2C;IAC3C;;;;KAIC;IACD;;+CAE2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,qFAAqF;IACrF,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,cAAc;AAClB;;AAEA,mEAAmE;AACnE;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,0CAA0C;IAC1C;;;;KAIC;IACD,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,sFAAsF;IACtF,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;AACf;;AAEA,2DAA2D;AAC3D;IACI,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C;;;;KAIC;IACD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf;;8CAE0C;IAC1C;;;;4BAIwB;AAC5B;;AAEA;IACI,sCAAsC;IACtC;;;;KAIC;IACD;;+CAE2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;;;;kEAIkE;AAClE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,OAAO;IACP,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,yEAAyE;AAC7E;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C;;;;KAIC;IACD,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;IACnC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,+CAA+C;IAC/C,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    font-family: \"Arial\", sans-serif;\n}\n.ppad{\n    padding-block: 60px;\n}\n\n.loginForm-body{\n    margin: 0;\n    padding: 0;\n    font-family: 'Arial', sans-serif;\n    background-color: #f0f0f0;\n    color:#636363;\n}\n.signin-container{\n    display: flex;\n    flex-direction: column;\n    place-content: center;\n    background-color: #ffffff;\n    color: #636363;\n}\n\n.loginForm-container {\n    display: grid;\n    place-items: center;\n    min-height: 100dvh;\n    height: auto;\n    width: 100%;\n}\n\n.loginForm-logo-section{\n    padding: 40px;\n    text-align: left;\n    border-radius: 7px;\n    border: 1px solid #505050;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.loginForm-button-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 20px;\n}\n\n.loginForm-description{\n    margin-bottom: 30px;\n    margin-top: 0;\n}\n\n.loginForm-header{\n    background-image: radial-gradient(circle, #c09f53, #856a2b);\n    color: #ffffff;\n    display: grid;\n    place-content: center;\n    line-height: 1.4;\n    grid-template-rows: 1fr;\n    overflow: hidden;\n}\n\n.loginForm-header-content{\n    margin: auto;\n    width: 550px;\n    padding-block: 40px;\n}\n\n.loginForm-header-content h1{\n    font-size: 2em;\n    font-weight: 600;\n    margin: 0;\n}\n\n.loginForm-signup{\n    padding: 10px 20px;\n    background-color: #ffffff;\n    color: #636363;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    border: 1px solid #c09f53;\n    border-radius: 30px;\n    margin: 10px;\n    text-decoration: none;\n    font-size: 16px;\n}\n\n.loginForm-signup-2{\n    text-decoration: none;\n    color: #636363;\n    margin-top: 20px;\n    border-radius: 30px;\n    padding: 10px 20px;\n}\n\n.loginForm-signup-2:hover, .loginForm-signup:hover{\n    background-color: #c09f53;\n    color: #ffffff;\n    transition: all 0.3s ease;\n    border: 1px solid #c09f53;\n    cursor: pointer;\n}\n\n.loginForm-overlay {\n    position: fixed;\n    top: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    display: grid;\n    place-content: center;\n    background: rgba(0, 0, 0, .7);\n}\n\n.loginForm {\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    background: radial-gradient(circle at top, rgba(188, 188, 188, .8) -10%, rgba(48, 48, 48, .6));\n    padding: 80px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    color: rgb(234, 234, 234);\n    backdrop-filter: saturate(180%) blur(20px);\n    -webkit-backdrop-filter: saturate(180%) blur(20px);\n    grid-column: 2/3;\n}\n\n.loginForm-overlay .loginForm {\n    width: 500px;\n}\n\n.loginForm label {\n    text-align: left;\n    display: block;\n    padding: 5px 0px;\n}\n\n.loginForm-inputField {\n    padding: 15px;\n    border: none;\n    width: 100%;\n    box-sizing: border-box;\n    font-size: 16px;\n    margin: 2px 0px;\n}\n\n.loginForm-forget {\n    padding: 15px;\n    color: rgb(234, 234, 234);\n    text-decoration: none;\n    display: block;\n    text-align: right;\n}\n\n.loginForm-logo {\n    width: 400px;\n}\n\n.loginForm-logo.--hideMobile {\n    display: none;\n}\n\n.intastellar-accounts-logo-container {\n    margin-top: 90px;\n    text-align: center;\n}\n\n.intastellar-accounts-logo{\n    width: 110px;\n}\n\n.poweredBy {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.loginForm-inputField.--btn {\n    background-color: #c09f53;\n    font-size: 16px;\n    color: #fff;\n    font-weight: bold;\n    letter-spacing: 5px;\n    text-transform: uppercase;\n}\n\n.loginForm-title {\n    font-size: 1.70em;\n    text-align: center;\n}\n\n.loginForm-service {\n    margin: 0 0 10px;\n}\n\n.loginForm-inputField.--link {\n    color: #fff;\n    text-decoration: none;\n    font-size: 14px;\n    text-align: center;\n    display: block;\n    margin: 10px 0px;\n}\n\n.graphic-container{\n    height: 100%;\n}\n\n.main-content-section{\n    padding: 50px;\n    color: #636363;\n}\n\n.used_by {\n    display: inline-block;\n    width: 50%;\n    height: 100px;\n    object-fit: contain;\n    object-position: center;\n    margin-inline: 50px;\n}\n\n.feature-list{\n    width: 1100px;\n    margin-inline: auto;\n}\n\n.testimonials{\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n}\n\n.key-numbers-section{\n    padding-block: 150px;\n    background-color: #fff;\n}\n\n@media screen and (min-width: 375px) and (max-width: 900px) {\n    .loginForm-container {\n        grid-template-columns: 1fr;\n    }\n\n    .loginForm-logo-section{\n        border: none;\n    }\n\n    .loginForm-logo {\n        padding: 0;\n        margin: 20px auto;\n    }\n\n    .loginForm-title{\n        font-size: 1.1em;\n        width: 100%;\n        margin: 0 auto;\n    }\n\n        .loginForm-header{\n        grid-template-columns: 1fr;\n        }\n\n    .loginForm-header-content{\n        width: 100%;\n        padding: 20px;\n    }\n\n    .loginForm {\n        padding: 40px;\n        background: radial-gradient(circle at top, rgba(188, 188, 188, .6) -10%, rgba(48, 48, 48, .4));\n    }\n\n    .loginForm-container {\n        background-position: -250px;\n        height: auto;\n    }\n\n    .signup {\n        overflow: scroll;\n    }\n\n    .loginForm-header, .signin-container{\n        height: auto !important;\n    }\n\n    .signin-container{\n        padding: 60px;\n    }\n\n    .intastellar-accounts-logo-container{\n        text-align: center;\n    }\n\n    .poweredBy{\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n\n    .intastellar-accounts-logo{\n        margin-bottom: 70px;\n    }\n\n    .graphic-container{\n        display: none;\n    }\n\n    .key-numbers-section{\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .used_by{\n        width: 150px;\n        margin: auto;\n        display: flex;\n    }\n}\n\n/* ——— Intastellar Consents login (Login.js only) ——— */\n.int-login {\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    background: #f7f4f0;\n    color: #e8e8e8;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\n/* ── Split layout ── */\n.int-login__split {\n    flex: 1;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    min-height: 100dvh;\n}\n\n.int-login__panel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: clamp(32px, 5vw, 72px) clamp(24px, 4vw, 64px);\n    box-sizing: border-box;\n}\n\n.int-login__panel--form {\n    background: #f7f4f0;\n}\n\n.int-login__panel--features {\n    position: relative;\n    border-left: 1px solid rgba(255, 255, 255, 0.06);\n    background:\n        radial-gradient(ellipse 110% 60% at 60% 10%, rgba(192, 159, 83, 0.12), transparent 55%),\n        linear-gradient(168deg, #141418 0%, #0c0c10 100%);\n    overflow: hidden;\n}\n\n.int-login__panel--features::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: radial-gradient(ellipse 80% 80% at 110% 110%, rgba(192, 159, 83, 0.07), transparent 60%);\n    pointer-events: none;\n}\n\n/* ── Features inner content ── */\n.int-login__features-inner {\n    position: relative;\n    width: 100%;\n    max-width: 420px;\n}\n\n.int-login__features-brand {\n    margin-bottom: 32px;\n}\n\n.int-login__features-logo {\n    height: auto;\n    max-width: min(100%, 230px);\n    display: block;\n    opacity: 0.88;\n    filter: brightness(0) invert(1);\n}\n\n.int-login__features-headline {\n    margin: 0 0 14px;\n    font-size: clamp(1.5rem, 2.8vw, 2rem);\n    font-weight: 700;\n    line-height: 1.22;\n    letter-spacing: -0.01em;\n    color: #f4f0ea;\n}\n\n.int-login__features-lede {\n    margin: 0 0 32px;\n    font-size: 0.9375rem;\n    line-height: 1.6;\n    color: #848a92;\n}\n\n.int-login__features-list {\n    list-style: none;\n    margin: 0 0 32px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.int-login__feature {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n}\n\n.int-login__feature-icon {\n    flex-shrink: 0;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 9px;\n    border: 1px solid rgba(192, 159, 83, 0.25);\n    background: rgba(192, 159, 83, 0.09);\n    color: #c0a053;\n    margin-top: 1px;\n}\n\n.int-login__feature-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.int-login__feature-title {\n    display: block;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #e8e4de;\n}\n\n.int-login__feature-desc {\n    display: block;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: #6a7280;\n}\n\n/* ── Stats row ── */\n.int-login__features-stats {\n    display: flex;\n    align-items: center;\n    gap: 0;\n    padding: 18px 20px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(0, 0, 0, 0.28);\n}\n\n.int-login__features-stat {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 3px;\n    text-align: center;\n}\n\n.int-login__features-stat-value {\n    font-size: 1rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    color: #c0a053;\n}\n\n.int-login__features-stat-label {\n    font-size: 0.68rem;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.32);\n}\n\n.int-login__features-stat-divider {\n    width: 1px;\n    height: 28px;\n    background: rgba(255, 255, 255, 0.07);\n    flex-shrink: 0;\n}\n\n/* ── Light form panel overrides ── */\n.int-login__panel--form .int-login__card {\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    max-width: 360px;\n}\n\n.int-login__panel--form .int-login__card::before {\n    display: none;\n}\n\n.int-login__panel--form .int-login__logo {\n    filter: none;\n    opacity: 1;\n    max-width: min(100%, 300px);\n}\n\n.int-login__panel--form .int-login__headline {\n    color: #1a1714;\n    font-size: clamp(1.6rem, 3vw, 2rem);\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    text-align: left;\n    margin-top: 36px;\n}\n\n.int-login__panel--form .int-login__lede {\n    color: #7a7068;\n    text-align: left;\n    margin-bottom: 28px;\n}\n\n.int-login__panel--form .int-login__signin-btn {\n    border-color: rgba(160, 128, 60, 0.5);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.18) 0%, rgba(160, 130, 60, 0.12) 100%);\n    color: #3d2f0e;\n    box-shadow: 0 2px 8px rgba(160, 128, 60, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.int-login__panel--form .int-login__signin-btn:hover:not(:disabled) {\n    border-color: rgba(160, 128, 60, 0.7);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.26) 0%, rgba(160, 130, 60, 0.2) 100%);\n    box-shadow: 0 4px 14px rgba(160, 128, 60, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.int-login__panel--form .int-login__signin-btn-inner-text {\n    color: #3d2f0e;\n}\n\n.int-login__panel--form .int-login__signin-btn-inner-text-email {\n    color: #7a6840;\n}\n\n.int-login__panel--form .int-login__signin-spinner {\n    border-color: rgba(61, 47, 14, 0.2);\n    border-top-color: #3d2f0e;\n}\n\n.int-login__panel--form .int-login__not-you {\n    text-align: left;\n}\n\n.int-login__panel--form .int-login__not-you-link {\n    color: #9a8a78;\n}\n\n.int-login__panel--form .int-login__not-you-link:hover {\n    color: #a38540;\n    border-bottom-color: rgba(163, 133, 64, 0.45);\n}\n\n.int-login__panel--form .int-login__divider {\n    color: #9a8a78;\n}\n\n.int-login__panel--form .int-login__divider::before,\n.int-login__panel--form .int-login__divider::after {\n    background: rgba(0, 0, 0, 0.08);\n}\n\n.int-login__panel--form .int-login__new-here-title {\n    color: #1a1714;\n}\n\n.int-login__panel--form .int-login__new-here-copy {\n    color: #7a7068;\n}\n\n.int-login__panel--form .int-login__new-here-btn {\n    border-color: rgba(160, 128, 60, 0.45);\n    color: #3d2f0e;\n}\n\n.int-login__panel--form .int-login__new-here-btn:hover {\n    border-color: rgba(160, 128, 60, 0.75);\n    background: rgba(192, 159, 83, 0.1);\n    color: #1a1714;\n}\n\n/* ── Responsive: collapse to single column on small screens ── */\n@media (max-width: 860px) {\n    .int-login__split {\n        grid-template-columns: 1fr;\n    }\n\n    .int-login__panel--features {\n        display: none;\n    }\n\n    .int-login__panel--form {\n        min-height: 100dvh;\n        padding: clamp(40px, 8vw, 80px) clamp(24px, 6vw, 48px);\n    }\n\n    .int-login__panel--form .int-login__card {\n        max-width: 100%;\n    }\n}\n\n.int-login__card {\n    width: 100%;\n    max-width: 440px;\n    padding: clamp(28px, 4vw, 42px);\n    border-radius: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: linear-gradient(\n        168deg,\n        rgba(54, 54, 58, 0.95) 0%,\n        rgba(28, 28, 32, 0.98) 100%\n    );\n    box-shadow:\n        0 28px 72px rgba(0, 0, 0, 0.5),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    position: relative;\n}\n\n.int-login__card::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 42%;\n    max-width: 200px;\n    height: 3px;\n    border-radius: 0 0 8px 8px;\n    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.9), transparent);\n    pointer-events: none;\n}\n\n.int-login__brand {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 22px;\n}\n\n.int-login__logo {\n    max-width: min(100%, 300px);\n    height: auto;\n    display: block;\n}\n\n/* First-visit clarity: product ↔ parent company (Login + Signup) */\n.icc-product-parent-ribbon {\n    margin: 0 0 20px;\n    padding: 12px 14px;\n    text-align: center;\n    font-size: 0.8125rem;\n    line-height: 1.45;\n    color: #c4c4c4;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    background: linear-gradient(\n        165deg,\n        rgba(192, 159, 83, 0.12) 0%,\n        rgba(0, 0, 0, 0.2) 100%\n    );\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.icc-product-parent-ribbon__product {\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: #f0e6d4;\n}\n\n.icc-product-parent-ribbon__sep {\n    margin: 0 0.35em;\n    color: rgba(192, 159, 83, 0.75);\n    font-weight: 600;\n}\n\n.icc-product-parent-ribbon__rest {\n    color: #a8a8a8;\n}\n\n.icc-product-parent-ribbon__link {\n    color: #d4b87a;\n    font-weight: 600;\n    text-decoration: underline;\n    text-decoration-color: rgba(192, 159, 83, 0.45);\n    text-underline-offset: 2px;\n}\n\n.icc-product-parent-ribbon__link:hover {\n    color: #e8d4a8;\n    text-decoration-color: rgba(192, 159, 83, 0.85);\n}\n\n.loginForm-header-content .icc-product-parent-ribbon--signup {\n    max-width: 520px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.int-login__headline {\n    margin: 0 0 12px;\n    font-size: clamp(1.32rem, 3.6vw, 1.68rem);\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-align: center;\n    line-height: 1.28;\n    color: #f4f4f4;\n}\n\n.int-login__lede {\n    margin: 0 0 18px;\n    font-size: 0.9375rem;\n    line-height: 1.55;\n    text-align: center;\n    color: #a3a3a3;\n}\n\n.int-login__trust {\n    list-style: none;\n    margin: 0 0 22px;\n    padding: 14px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(0, 0, 0, 0.22);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.int-login__trust-item {\n    position: relative;\n    margin: 0;\n    padding-left: 20px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #c6c6c6;\n    line-height: 1.4;\n    text-align: left;\n}\n\n.int-login__trust-item::before {\n    content: \"\";\n    position: absolute;\n    left: 2px;\n    top: 0.52em;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: linear-gradient(145deg, rgba(192, 159, 83, 0.95), rgba(192, 159, 83, 0.4));\n    box-shadow: 0 0 10px rgba(192, 159, 83, 0.3);\n}\n\n.int-login__sso {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n}\n\n/* Primary action — matches dashboard / settings gold CTA */\n.int-login__signin-btn {\n    width: 100%;\n    margin: 0;\n    padding: 14px 22px;\n    border-radius: 12px;\n    border: 1px solid rgba(192, 159, 83, 0.48);\n    background: linear-gradient(\n        180deg,\n        rgba(192, 159, 83, 0.28) 0%,\n        rgba(160, 130, 70, 0.2) 100%\n    );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #faf6ee;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    font-family: inherit;\n    letter-spacing: 0.02em;\n    line-height: 1.3;\n    cursor: pointer;\n    box-shadow:\n        0 10px 28px rgba(0, 0, 0, 0.35),\n        inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    transition:\n        border-color 0.2s ease,\n        background 0.2s ease,\n        transform 0.15s ease,\n        box-shadow 0.2s ease;\n}\n\n.int-login__signin-btn:hover:not(:disabled) {\n    border-color: rgba(192, 159, 83, 0.72);\n    background: linear-gradient(\n        180deg,\n        rgba(192, 159, 83, 0.38) 0%,\n        rgba(160, 130, 70, 0.28) 100%\n    );\n    box-shadow:\n        0 12px 32px rgba(0, 0, 0, 0.4),\n        inset 0 1px 0 rgba(255, 255, 255, 0.12);\n}\n\n.int-login__signin-btn:active:not(:disabled) {\n    transform: translateY(1px);\n}\n\n.int-login__signin-btn:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.75);\n    outline-offset: 3px;\n}\n\n.int-login__signin-btn:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.int-login__signin-btn-inner {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.int-login__signin-btn-inner-image {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n}\n\n.int-login__signin-btn-inner-text {\n    font-size: 0.9375rem;\n    font-weight: 600;\n    color: #faf6ee;\n}\n\n.int-login__signin-spinner {\n    width: 1.1em;\n    height: 1.1em;\n    border: 2px solid rgba(250, 246, 238, 0.25);\n    border-top-color: #faf6ee;\n    border-radius: 50%;\n    animation: int-login-spin 0.65s linear infinite;\n    flex-shrink: 0;\n}\n\n.int-login__signin-btn-inner-text-email {\n    font-size: 0.8125rem;\n    font-weight: 400;\n    color: #c6c6c6;\n    display: block;\n}\n\n@keyframes int-login-spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.int-login__not-you {\n    margin: 14px 0 0;\n    text-align: center;\n}\n\n.int-login__not-you-link {\n    font-size: 0.8125rem;\n    font-weight: 500;\n    color: #8f9aad;\n    text-decoration: none;\n    border-bottom: 1px solid transparent;\n    transition: color 0.2s ease, border-color 0.2s ease;\n}\n\n.int-login__not-you-link:hover {\n    color: #c0a053;\n    border-bottom-color: rgba(192, 159, 83, 0.45);\n}\n\n/* \"New here?\" — the login page is the de facto landing page for anyone\n   arriving without an account, so this needs to be a real, discoverable\n   section, not a buried link. Deliberately styled as a secondary/outline\n   button (vs. the filled gold \"Sign in\" CTA) so returning users still land\n   on Sign in first, but new visitors don't have to hunt for it. */\n.int-login__divider {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 22px 0;\n    color: #8f9aad;\n    font-size: 0.6875rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n}\n\n.int-login__divider::before,\n.int-login__divider::after {\n    content: \"\";\n    flex: 1;\n    height: 1px;\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.int-login__new-here-title {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #faf6ee;\n    margin: 0 0 4px;\n}\n\n.int-login__new-here-copy {\n    font-size: 0.8125rem;\n    color: #9aa3b2;\n    margin: 0 0 14px;\n    line-height: 1.5;\n}\n\n.int-login__new-here-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 12px 22px;\n    border-radius: 12px;\n    border: 1px solid rgba(192, 159, 83, 0.4);\n    background: transparent;\n    color: #e7d9b8;\n    font-size: 0.875rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-decoration: none;\n    transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;\n}\n\n.int-login__new-here-btn:hover {\n    border-color: rgba(192, 159, 83, 0.75);\n    background: rgba(192, 159, 83, 0.08);\n    color: #faf6ee;\n}\n\n/* SSO / identity trust (Login.js footer) */\n.int-login__identity {\n    margin-top: 26px;\n    padding: 18px 16px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(192, 159, 83, 0.18);\n    background: linear-gradient(\n        165deg,\n        rgba(192, 159, 83, 0.07) 0%,\n        rgba(0, 0, 0, 0.28) 55%\n    );\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.int-login__identity-strip {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    margin-bottom: 16px;\n}\n\n.int-login__identity-icon {\n    flex-shrink: 0;\n    width: 44px;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    background: rgba(192, 159, 83, 0.1);\n    border: 1px solid rgba(192, 159, 83, 0.22);\n    color: #d4b76a;\n}\n\n.int-login__identity-svg {\n    width: 26px;\n    height: 26px;\n    display: block;\n}\n\n.int-login__identity-copy {\n    min-width: 0;\n    flex: 1;\n}\n\n.int-login__identity-kicker {\n    margin: 0 0 6px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: #c0a053;\n}\n\n.int-login__identity-lede {\n    margin: 0;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: #b0b0b0;\n    text-align: left;\n}\n\n.int-login__identity-product {\n    color: #e2e2e2;\n    font-weight: 600;\n}\n\n.int-login__identity-brand {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding-top: 14px;\n    margin-top: 4px;\n    border-top: 1px solid rgba(255, 255, 255, 0.07);\n    text-decoration: none;\n    transition: opacity 0.2s ease;\n}\n\n.int-login__identity-brand:hover {\n    opacity: 0.92;\n}\n\n.int-login__identity-brand:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.75);\n    outline-offset: 4px;\n    border-radius: 8px;\n}\n\n.int-login__identity-brand-label {\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    color: #6a6a6a;\n}\n\n.int-login__identity-logo {\n    height: auto;\n    max-width: 128px;\n    width: 100%;\n    opacity: 0.95;\n}\n\n.int-login__identity-trustline {\n    margin: 14px 0 0;\n    padding-top: 12px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    font-size: 0.65rem;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    text-align: center;\n    color: #5c6570;\n    line-height: 1.45;\n}\n\n@media (max-width: 480px) {\n    .int-login__card {\n        padding: 24px 18px 28px;\n        border-radius: 14px;\n    }\n\n    .int-login__lede {\n        font-size: 0.875rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
